/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
var Parser = require('expr-eval').Parser

const commands = ['--eval', '--path']

var parser = new Parser({
    operators: {
    // These default to true, but are included to be explicit
    add: true,
    concatenate: true,
    conditional: true,
    divide: true,
    factorial: true,
    multiply: true,
    power: true,
    remainder: true,
    subtract: true,

    // Disable and, or, not, <, ==, !=, etc.
    logical: true,
    comparison: true,

    // Disable 'in' and = operators
    'in': true,
    assignment: true
    }
})

parser.functions.splice = function (element, array) {
    let index = array.indexOf(element)
    array.splice(index, 1)

    return array
}

let Eval = (expr, variables = {}) => {
    let expression = parser.parse(expr)
    let result = expression.evaluate(variables)
    //console.log('Eval Result: ', result)
    return result
}

let Parse = (obj, val_address) => {
    let address = val_address.split(".")
    address[0] = address[0].slice(1)
    // console.log('Value_Address: ', address)
    // console.log('Parent Object: ', obj)
    let value = address.reduce((object, key) => {
        return object[key]
    }, obj)

    return value
}

let Evaluate = (obj, expr) => {
    //console.log('----Evaluating---- ', expr)
    let args = expr.split(" ")
    let command = args[0]

    if (commands.includes(command)) {
        args.shift()
        // console.log('Arguments: ', args)
        // console.log('Command: ', command)
        if (command === '--eval') {
            let variable_list = args.filter((arg) => {
                return arg[0] === '$'
            })
        
            let new_args = args.map((arg, i) => {
                //console.log('Argument ' + i + " is " + arg)
                if (arg[0] === '$') {
                    let address_val = Parse(obj, arg)
                    //console.log('Address Value: ', address_val)
                    return address_val
                    // if (address_val.constructor === Array) {
                    //     //address_val =  JSON.stringify(address_val)
                    //     //console.log('Address Value Stringifying Array: ', JSON.stringify(address_val))
                        
                    // } else {
                    //     return address_val
                    // }
                } else {
                    return arg
                }
            })

            // console.log('New Args: ', new_args)
            // console.log('New Args Length: ', new_args.length)

            if (new_args.length === 1) {
                if (typeof new_args[0] === 'string') {
                    //console.log('Single Result: ', new_args[0])
                    return new_args[0]
                } else if (typeof new_args[0] != Array) {
                    //console.log('Single Result: ', new_args[0])
                    return new_args[0]
                }
            }
        
            let new_expr = new_args.join("")
            //console.log('New Expression: ', new_expr)
        
            let result
            
            try {
                result = Eval(new_expr)
            }
            catch (err) {
                console.log('Error in Expr: ', expr)
                console.log('Error is: ', err)
                result = 'Error in ' + expr
            }
        
            // console.log('Args: ', args)
            // console.log('Variables: ', variable_list)
            // console.log('New Expression: ', new_expr)
            console.log('Result: ', result)
            return result
        } else if (command === '--path') {
            if (args.length === 1 && args[0][0] === '$') {
                let path = args[0].split(".")
                path[0] = path[0].slice(1)

                return path
            } else {
                return 'Invalid Path argument :: ' + args.join(" ")
            }
        }
    } else {
        return 'Invalid Command :: ' + command
    }
}



export default Evaluate